import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {User} from '../../../auth/symbols';
import {GeneticData} from '../../types/dashboard-genetics-general.types';
import {GeneticFileProcessingStatus} from '../../types/dashboard-genetics-processing.types';

@Injectable()
export class DashboardGeneticsUploadService {

  constructor(private http: HttpClient) {
  }

  /**
   * Upload genetic data to backend.
   * Should contain a file, so convert to form data structure.
   *
   * If patient UID is provided, the genetic data will be associated with the patient.
   */
  public uploadGenFile(file: File, checksum: string, patientUid = ''): Observable<void> {
    const url = `/api/research/upload-genetic/`;
    const data = new FormData();
    data.append('file', file);
    data.append('patient_uid', patientUid);
    data.append('checksum', checksum);
    return this.http.put<void>(url, data);
  }
}
